import styled, { css } from 'styled-components';

import { Container } from '@xing-com/layout-primitives';
import { mediaConfined, mediaWideNavless } from '@xing-com/layout-tokens';
import { spaceXXL, spaceXL } from '@xing-com/tokens';

import { useHideAside } from '../../hooks';

export const ContentContainer: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const hideAside = useHideAside();

  return (
    <ContentContainerStyles variant="wide" $hideAside={hideAside}>
      {children}
    </ContentContainerStyles>
  );
};

const flexStyles = css`
  display: flex;
  align-items: center;
  max-width: 648px;
`;
const gridStyles = css`
  @media ${mediaWideNavless} {
    display: grid;
    gap: ${spaceXXL};

    /* grid-template-columns: minmax(270px, 400px) minmax(600px, 800px); Previous, check with Silke */
    grid-template-columns: minmax(270px, calc(400 / 1256 * 100%)) minmax(
        300px,
        65.6%
      );
  }
`;

const ContentContainerStyles = styled(Container)<{ $hideAside: boolean }>`
  display: block;
  margin-top: ${spaceXL};
  padding: 0 20px;

  @media ${mediaConfined} {
    padding: 0 ${({ $hideAside }) => ($hideAside ? 0 : spaceXXL)};
  }

  @media ${mediaWideNavless} {
    margin-top: ${spaceXXL};
  }

  ${({ $hideAside }) => ($hideAside ? flexStyles : gridStyles)}
`;
